import Skeleton from "../../../Components/Common/Skeleton/Skeleton";

const DOC_ROWS = [0, 1, 2, 3];
const QA_ROWS = [0, 1, 2];

const PreconChecklistSkeleton = () => (
  <div className="gc-precon-commercial">
    <div className="precon-layout">
      {/* Project header */}
      <div style={{ marginBottom: 20 }}>
        <Skeleton width="40%" height={22} borderRadius="6px" style={{ marginBottom: 10 }} />
        <Skeleton width="60%" height={14} borderRadius={undefined} />
      </div>

      {/* Progress bar */}
      <div style={{ marginBottom: 24 }}>
        <Skeleton width="100%" height={14} borderRadius="8px" style={{ marginBottom: 8 }} />
        <Skeleton width="100%" height={10} borderRadius="8px" />
      </div>

      {/* Two-column panels */}
      <div className="two-col">
        {/* Document panel */}
        <div style={{ flex: 1 }}>
          <Skeleton width="45%" height={18} borderRadius="6px" style={{ marginBottom: 14 }} />
          {DOC_ROWS.map((i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "12px 0",
                borderBottom: i < DOC_ROWS.length - 1 ? "1px solid var(--border, #e5e7eb)" : "none",
              }}
            >
              <Skeleton width={36} height={36} borderRadius="8px" />
              <div style={{ flex: 1 }}>
                <Skeleton width="60%" height={13} borderRadius={undefined} style={{ marginBottom: 6 }} />
                <Skeleton width="40%" height={11} borderRadius={undefined} />
              </div>
              <Skeleton width={72} height={30} borderRadius="6px" />
            </div>
          ))}
        </div>

        {/* QA panel */}
        <div style={{ flex: 1 }}>
          <Skeleton width="45%" height={18} borderRadius="6px" style={{ marginBottom: 14 }} />
          {QA_ROWS.map((i) => (
            <div key={i} style={{ marginBottom: 18 }}>
              <Skeleton width="75%" height={13} borderRadius={undefined} style={{ marginBottom: 8 }} />
              <Skeleton width="100%" height={38} borderRadius="6px" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default PreconChecklistSkeleton;
